import { AxiosResponse } from "axios";
import AxiosService from "./Axios"
import BaseApi from "./BaseApi";

const BASE_URL = "/gateway";

class GatewayApi extends BaseApi {

    constructor() {
        super(BASE_URL);
    }

    public async saveSettings(gatewayId: string, type: string, settings: any): Promise<AxiosResponse<any>> {
        return AxiosService.post(BASE_URL + '/gateway-settings/save', {
            gatewayId: gatewayId,
            groupSettingsType: type,
            groupSettings: settings,
        });
    }

    public async sendRawTransferPacket(sendPacketRequest: SendPacketRequest): Promise<AxiosResponse<any>> {
        return AxiosService.post(BASE_URL + '/data-debug/raw-transfer/send-packet', sendPacketRequest);
    }

    public async clearRawTransferPackets(clearPacketsRequest: ClearPacketRequest): Promise<AxiosResponse<any>> {
        return AxiosService.post(BASE_URL + '/data-debug/raw-transfer/clear-packets', clearPacketsRequest);
    }


    public async getRawTransferTxRxPackets(gatewayId: string, portName: string): Promise<AxiosResponse<any>> {
        return AxiosService.get(BASE_URL + '/data-debug/raw-transfer/packets', {
            params: {
                gatewayId: gatewayId,
                portName: portName,
            }
        });
    }

    public async getGatewayViewByGatewayId(gatewayId: string): Promise<AxiosResponse<any>> {
        return AxiosService.get(BASE_URL + '/gateway-view/gateway-id/' + gatewayId);
    }

    public async getAllGatewayViews(): Promise<AxiosResponse<any>> {
        return AxiosService.get(this.baseUrl + '/gateway-view/all');
    }

    public async invokeService(gatewayId: string, serviceKey: string, parameters: any): Promise<AxiosResponse<any>> {
        return AxiosService.post(BASE_URL + '/service/invoke', {
            gatewayId: gatewayId,
            serviceKey: serviceKey,
            parameters: parameters,
        });
    }

    public async queryViews(request: QueryGatewayViewsRequest): Promise<AxiosResponse<any>> {
        return AxiosService.post(BASE_URL + '/gateway-view/query', request);
    }

}

interface SendPacketRequest {
    gatewayId: string;
    portName: string;
    payload: number[];
}

interface ClearPacketRequest {
    gatewayId: string;
    portName: string;
}

interface QueryGatewayViewsRequest {
    pageNo: number;
    pageSize: number;

    gatewayId?: string;
    productModel?: string;
    search?: string;
}

export default GatewayApi;
